import { eachDayOfInterval, format } from 'date-fns';
import { Impacts }                   from '@/views/events/submodules/events-detail.types';

export const useGenerateImpactsList = (dateRange: Array<Date | string>, impacts?: string[]): Impacts[] => {
  const days: { start: Date; end: Date } = {
    start: impacts ? new Date(dateRange[ 0 ]) : dateRange[ 0 ] as Date,
    end: impacts ? new Date(dateRange[ 1 ]) : dateRange[ 1 ] as Date,
  };

  return eachDayOfInterval(days)
    .map((day: Date, index: number) => ({
      day: format(day, 'EEE, d MMM'),
      value: impacts ? impacts[ index ] : '',
    }));
};
